"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _button = _interopRequireDefault(require("britive-design-system/core/components/button"));

var _textarea = _interopRequireDefault(require("britive-design-system/core/components/textarea"));

var _propTypes = require("prop-types");

var _react = _interopRequireWildcard(require("react"));

var _commonConstants = require("../../../../utils/common-constants");

var _commonUtils = require("../../../../utils/common-utils");

var _constants = require("./constants");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var styles = "/* Add custom scrollbar style for Chrome, Safari, FF and Edge */\n.input-json-main-container {\n  padding-top: 3rem;\n  padding-left: 3.5rem;\n  padding-right: 3.5rem;\n  padding-bottom: 3rem;\n  overflow-y: auto; }\n  .input-json-main-container::-webkit-scrollbar {\n    width: 0.5rem;\n    height: 0.5rem; }\n  .input-json-main-container::-webkit-scrollbar-track {\n    border-radius: 0.5rem;\n    margin-top: 0.125rem; }\n  .input-json-main-container::-webkit-scrollbar-thumb {\n    border-radius: 0.5rem;\n    background-color: #c6c6c6; }\n  .input-json-main-container::-webkit-scrollbar-thumb:hover {\n    background-color: #6f6f6f; }\n  .input-json-main-container .bds-textarea-box-read-only {\n    background-color: #f4f4f4 !important;\n    color: #525252 !important; }\n";
  var fileName = "compone_PolicyJsonEditor";
  var element = document.querySelector("style[data-sass-component='compone_PolicyJsonEditor']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var AddPolicyJSON = function AddPolicyJSON(_ref) {
  var validationHook = _ref.validationHook,
      openNotification = _ref.openNotification,
      editReadOnly = _ref.editReadOnly,
      validationErrors = _ref.validationErrors,
      translatedStrings = _ref.translatedStrings;
  var jsonContainer = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (editReadOnly) {
      openNotification(_commonConstants.warningNotificationType, translatedStrings.readOnlyPolicyJSONMessage);
    }
  }, [editReadOnly]);
  (0, _react.useEffect)(function () {
    // below code is to handle form container div height in all cases(with error and without error) to avoid extra scroll bar
    if (jsonContainer !== null && jsonContainer !== void 0 && jsonContainer.current) {
      jsonContainer.current.style.height = "calc(100vh - ".concat((0, _commonUtils.getHeightFromTop)(jsonContainer.current), "px)");
    }
  }, [jsonContainer.current, validationErrors]);

  var onCopy = function onCopy() {
    if (validationHook.values.JSONInputData) {
      navigator.clipboard.writeText(validationHook.values.JSONInputData);
      openNotification(_commonConstants.successNotificationType, translatedStrings.policySuccessCopy);
    } else openNotification(_commonConstants.errorNotificationType, translatedStrings.policyFailedCopy);
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.inputJsonMainContainer,
    ref: jsonContainer
  }, /*#__PURE__*/_react.default.createElement(_button.default, {
    variant: "secondary",
    size: "small",
    onClick: onCopy
  }, translatedStrings.copyBtn), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginTop: '10px'
    }
  }, /*#__PURE__*/_react.default.createElement(_textarea.default, {
    height: "60vh",
    label: translatedStrings.policyFormat,
    value: validationHook.values.JSONInputData,
    onChange: function onChange(e) {
      return validationHook.handleChange(validationHook.names.JSONInputData, e.target.value);
    },
    error: validationHook.touched.JSONInputData && Boolean(validationHook.errors.JSONInputData),
    onBlur: function onBlur() {
      return validationHook.handleBlur(validationHook.names.JSONInputData);
    },
    errorMsg: validationHook.errors.JSONInputData,
    readOnly: Boolean(editReadOnly)
  }))));
};

AddPolicyJSON.propTypes = {
  validationHook: _propTypes.PropTypes.object,
  openNotification: _propTypes.PropTypes.func,
  editReadOnly: _propTypes.PropTypes.bool,
  validationErrors: _propTypes.PropTypes.object,
  translatedStrings: _propTypes.PropTypes.object
};
var _default = AddPolicyJSON;
exports.default = _default;